<template>
  <main id="check_driver_info" class="common_base">
    <el-dialog title="司机信息" :visible.sync="driver.showDriverCheckDialog">
      <section>
        <el-row class="border-left-title">基础信息</el-row>
        <el-base-info :list="baseInfoList" />
        <el-row class="border-left-title">照片信息</el-row>
        <section class="check_car_info_photo_info">
          <el-row>
            <el-col
              :span="item.span || 12"
              v-for="(item, index) in imageConfig.imageList"
              :key="index"
            >
              <!-- <p class="photo_title_info">{{item.title}}</p> -->
              <el-image-uploader ref="imageUpload" :imageObj="item" />
            </el-col>
          </el-row>
        </section>
        <el-row v-if="contractList.length" class="border-left-title"
          >合同信息</el-row
        >
        <section class="contract_info" v-if="contractList.length">
          <el-contract-card
            v-for="(item, index) in contractList"
            :key="index"
            :detail="item"
          />
        </section>
      </section>
    </el-dialog>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import * as constant from '../../constant/common-type.ts'
import commonImageUploader from '../../components/console-common/common-image-uploader.vue'
import contractCard from '../../components/console-common/contract-board.vue'
import commonBaseInfo from '../../components/console-common/common-base-info.vue'
import { classifyName, sexName } from '../../constant/driver-type.ts'
import moment from 'moment'
export default {
  created() {
    this.getContractList()
    this.getDriverDetailList()
    this.getImageList()
  },
  components: {
    'el-image-uploader': commonImageUploader,
    'el-contract-card': contractCard,
    'el-base-info': commonBaseInfo,
  },
  data() {
    return {
      constant: constant,
      classifyName: classifyName,
      sexName: sexName,
      contractList: [],
      baseInfoList: [],
      imageConfig: {},
    }
  },
  computed: {
    ...mapState('driver', ['driverDetail']),
    ...mapState({
      driver: (state) => state.driver,
    }),
  },
  methods: {
    getImageList() {
      this.imageConfig = {
        imageList: [
          {
            limit: 2,
            title: '身份证照片',
            type: 'check',
            span: 12,
            fileList: this.driverDetail.idNoPhotos,
            key: 'idNoPhotos',
            disabled: true,
          },
          {
            limit: 2,
            title: '驾驶证',
            key: 'drivingLicencePhotos',
            span: 12,
            fileList: this.driverDetail.drivingLicencePhotos,
            type: 'check',
            disabled: true,
          },
          {
            limit: 1,
            title: '网约车人证',
            key: 'onlineLicensePhotos',
            span: 24,
            fileList: this.driverDetail.onlineLicensePhotos,
            type: 'check',
            disabled: true,
          },
        ],
      }
    },
    getDriverDetailList() {
      this.baseInfoList = [
        {
          label: '姓名',
          val: this.driverDetail.driverName,
        },
        {
          label: '身份证号',
          val: this.driverDetail.idNo,
        },
        {
          label: '性别',
          val: sexName[this.driverDetail.sex],
        },
        {
          label: '注册手机号',
          val: this.driverDetail.mobile,
        },
        {
          label: '联系方式',
          val: this.driverDetail.contact,
        },
        {
          label: '司机状态',
          val: constant.contractStatusName[this.driverDetail.status],
        },
        {
          label: '驾驶证有效期',
          val: this.driverDetail.drivingLicenceValidityType
            ? '长期'
            : this.driverDetail.drivingLicenceValidityStart &&
              this.driverDetail.drivingLicenceValidityEnd
            ? `${moment(this.driverDetail.drivingLicenceValidityStart).format(
                'YYYY-MM-DD'
              )} 至 ${moment(
                this.driverDetail.drivingLicenceValidityEnd
              ).format('YYYY-MM-DD')}`
            : '--',
        },
        {
          label: '挂靠公司',
          span: 24,
          val: this.driverDetail.attachCompany,
        },
        {
          label: '紧急联系人',
          val: this.driverDetail.emergencyContactName,
        },
        {
          label: '紧急联系人联系方式',
          val: this.driverDetail.emergencyContactMobile,
        },
        {
          label: '居住地址',
          span: 24,
          val: this.driverDetail.address,
        },
        {
          label: '驾驶证类别',
          val: this.driverDetail.drivingLicenceType,
        },
        {
          label: '经办人',
          val: this.driverDetail.operator,
        },
        {
          label: '备注',
          val: this.driverDetail.remark,
          span: 24,
        },
      ]
    },
    getContractList() {
      if (!this.driverDetail.contracts.length) return
      this.driverDetail.contracts.forEach((item) => {
        let obj = {
          orderNo: '',
          status: '',
          list: [],
        }
        obj.orderNo = item.contractCode
        obj.status = item.contractProcess
        obj.list = [
          {
            key: '司机姓名',
            val: item.driverName,
          },
          {
            key: '车牌号',
            val: item.plateNumber,
            push: 4,
          },
          {
            key: '业务模式',
            val: this.constant.leaseMode[item.leaseMode],
            span: 24,
          },
          {
            key: '合同有效期',
            val: `${moment(item.startTime).format('YYYY-MM-DD')} 至 ${moment(
              item.endTime
            ).format('YYYY-MM-DD')}`,
            span: 24,
          },
        ]
        this.contractList.push(obj)
      })
    },
  },
}
</script>

<style lang="stylus">
#check_driver_info
  .contract-board
    border none
    width 400px
    margin-bottom 8px
</style>
